import React from "react";

const Myrfqs = () => {

    return (
        <div className="buyer-dashboard">
            <div className="text">Welcome to Amtpl My RFQs page</div>


        </div>
    );
};

export default Myrfqs